import { type Session } from '@supabase/supabase-js'
import { create } from 'zustand'
import { supabase } from '@/lib/supabase'

interface AuthUser {
  id: string
  email: string
  role: string[]
  session: Session | null
}

interface AuthState {
  auth: {
    user: AuthUser | null
    isLoading: boolean
    setUser: (user: AuthUser | null) => void
    setSession: (session: Session | null) => void
    signOut: () => Promise<void>
    reset: () => void
  }
}

export const useAuthStore = create<AuthState>()((set) => ({
  auth: {
    user: null,
    isLoading: true,

    setUser: (user) =>
      set((state) => ({
        auth: { ...state.auth, user, isLoading: false },
      })),

    setSession: (session) =>
      set((state) => {
        if (session?.user) {
          return {
            auth: {
              ...state.auth,
              user: {
                id: session.user.id,
                email: session.user.email!,
                role: ['user'],
                session,
              },
              isLoading: false,
            },
          }
        }
        return {
          auth: {
            ...state.auth,
            user: null,
            isLoading: false,
          },
        }
      }),

    signOut: async () => {
      await supabase.auth.signOut()
      set((state) => ({
        auth: {
          ...state.auth,
          user: null,
        },
      }))
    },

    reset: () =>
      set((state) => ({
        auth: {
          ...state.auth,
          user: null,
          isLoading: false,
        },
      })),
  },
}))
